import * as React from 'react';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductWithAFrameData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { FrameMeasurements } from './FrameMeasurements.js';

const FrameMeasurementsContainer = ()=>{
    const { activeVariant: { frameMeasurements  } ,  } = useProductWithAFrameData();
    if (!frameMeasurements) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(FrameMeasurements, {
        measurements: frameMeasurements
    });
};

export { FrameMeasurementsContainer };
//# sourceMappingURL=FrameMeasurementsContainer.js.map
